import { render, staticRenderFns } from "./canvasTip.vue?vue&type=template&id=ceba1670&scoped=true&"
import script from "./canvasTip.vue?vue&type=script&lang=js&"
export * from "./canvasTip.vue?vue&type=script&lang=js&"
import style0 from "./canvasTip.vue?vue&type=style&index=0&id=ceba1670&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceba1670",
  null
  
)

export default component.exports